import React from 'react'

import { DateTime } from 'luxon'

import { api } from '../api'
import { SupportDiagnostics } from './SupportDiagnostics'

export interface ChatBubbleProps {
  message: Api_Chat.ChatMessage
  isCurrentUser?: boolean
  isSending?: boolean
}

const ChatBubbleToWrap: React.FC<ChatBubbleProps> = ({
  message,
  isCurrentUser,
  isSending,
}) => {
  if (message.type !== 'text') {
    return <div />
  }
  const supportDatabase = message.metadata?.supportDatabase

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: isCurrentUser ? 'row' : 'row-reverse',
        justifyContent: 'flex-end',
        paddingTop: 8,
      }}>
      <div
        style={{
          fontSize: 14,
          textAlign: isCurrentUser ? 'right' : 'left',
          maxWidth: '80%',
        }}>
        <div
          style={{
            margin: 4,
            marginTop: 0,
            padding: 8,
            backgroundColor: isCurrentUser ? '#F3F3F3' : '#DCDCDC',
            borderRadius: 4,
          }}>
          <div className="is-size-7">
            {DateTime.fromISO(message.createdAt).toLocaleString({
              ...DateTime.DATETIME_MED,
              locale: 'en-US',
            })}
          </div>
          <span className="has-text-black">{message.content.text}</span>
          {supportDatabase && (
            <div>
              <a
                href={api.supportDatabaseDownloadUrl(message.id)}
                target="_blank"
                rel="noopener noreferrer">
                Download local database (
                {(supportDatabase.size / (1024 * 1024)).toFixed(1)} MB)
              </a>
            </div>
          )}
          {message.metadata?.diagnostics && (
            <SupportDiagnostics diagnostics={message.metadata.diagnostics} />
          )}
        </div>
      </div>
      <figure className="image is-24x24" style={{ paddingTop: 6 }}>
        {message.creator?.profilePicture?.url && (
          <img
            src={message.creator.profilePicture.url}
            className="is-rounded"
            alt=""
          />
        )}
      </figure>
    </div>
  )
}

export const ChatBubble = React.memo(ChatBubbleToWrap)
